export const Functions = {
  create: false,
  delete: true,
  detail: false,
  search: true,
};

export const PageName = '申报绿途会员证列表';
